import { CustomElement, resolve } from 'aurelia';
import { AccountService } from '../../services';
import template from './welcome-modal.html';
import './welcome-modal.css';

// First-visit welcome overlay. Renders only while AccountService.welcomeOpen is set (an
// anonymous visitor who has not dismissed it before). Reuses the shared modal shell and the
// login-btn styles, and adds a benefits list plus a "Create free account" CTA. All state and
// the dismiss/sign-up behavior live in AccountService.
export class WelcomeModalElement {
  readonly account: AccountService = resolve(AccountService);
}

export const WelcomeModal = CustomElement.define({
  name: 'welcome-modal',
  template
}, WelcomeModalElement);
